// components/ChristmasTree.js
import React from 'react';

const ChristmasTree = ({ variant }) => {
  const baseColor = variant === 'dark' ? 'green-800' : 'green-600';
  const midColor = variant === 'dark' ? 'green-700' : 'green-500';
  const lightColor = variant === 'dark' ? 'green-600' : 'green-400';
  
  return (
    <div className="relative flex justify-center align-center">
      {/* Tree Layers Container */}
      <div className="relative left-[60px]">
        {/* Star - Repositioned */}
        <div className="relative -top-1 -left-2 z-10">
          <div className="w-4 h-4 bg-yellow-300 rotate-45 transform animate-pulse" />
        </div>
        
        {/* Top Section */}
        <div className={`w-0 h-0 border-l-[30px] border-r-[30px] border-b-[40px]
          border-l-transparent border-r-transparent bg-gradient-to-b
          border-b-${lightColor} transform -translate-x-1/2 relative z-10`}>
          {/* Decorations */}
          <div className="absolute -left-2 top-2 w-2 h-2 bg-red-500 rounded-full" />
          <div className="absolute left-1 top-4 w-2 h-2 bg-yellow-300 rounded-full" />
        </div>
        
        {/* Middle Section */}
        <div className={`w-0 h-0 border-l-[45px] border-r-[45px] border-b-[60px]
          border-l-transparent border-r-transparent border-b-${midColor}
          transform -translate-x-1/2 -mt-2 relative z-10`}>
          {/* Decorations */}
          <div className="absolute -right-2 top-4 w-2 h-2 bg-blue-400 rounded-full" />
          <div className="absolute left-3 top-6 w-2 h-2 bg-red-500 rounded-full" />
        </div>
        
        {/* Bottom Section */}
        <div className={`w-0 h-0 border-l-[60px] border-r-[60px] border-b-[80px]
          border-l-transparent border-r-transparent border-b-${baseColor}
          transform -translate-x-1/2 -mt-2 relative z-10`}>
          {/* Decorations */}
          <div className="absolute -left-3 top-6 w-2 h-2 bg-yellow-300 rounded-full" />
          <div className="absolute right-1 top-8 w-2 h-2 bg-red-500 rounded-full" />
          <div className="absolute left-2 top-10 w-2 h-2 bg-blue-400 rounded-full" />
        </div>
        
        {/* Trunk */}
        <div className="w-12 h-16 bg-yellow-800 transform -translate-x-1/2
          rounded-sm shadow-md relative z-10">
          {/* Trunk texture */}
          <div className="absolute left-2 top-2 w-1 h-8 bg-yellow-900 rounded-full opacity-50" />
          <div className="absolute right-2 top-4 w-1 h-6 bg-yellow-900 rounded-full opacity-50" />
        </div>
      </div>
    </div>
  );
};

export default ChristmasTree;